import Status from "components/base/Status";
import { Link } from "react-router-dom";

const ProductPlansView = ({ plans }) => {
  return (
    <div className="overflow-auto -mx-2 text-sm">
      <table className="with-line">
        <thead className="whitespace-nowrap">
          <tr>
            <th className="py-3">Plan(s)</th>
            <th className="py-3">State</th>
            <th className="py-3 text-right">Quantity</th>
          </tr>
        </thead>
        <tbody>
          {plans.map((plan) => (
            <tr key={plan.id ?? `${plan.name}-${plan.qty}-${plan.state}`}>
              <td className="">
                <Link to={`/order-scheduler/plans/${plan.id}`} target="_blank">
                  {plan.name}
                </Link>
              </td>
              <td className="px-1">
                <Status status={plan.state} inline />
              </td>
              <td className="text-right">{Math.abs(plan.qty ?? 0)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductPlansView;
